import React, { Dispatch, ReactElement, SetStateAction } from 'react';
import { Checkbox, CheckboxGroup } from 'idsk-react-components';
import './formCheckBox.scss';

interface FormCheckboxProps<T> {
  formData: T;
  setFormData: Dispatch<SetStateAction<T>>;
  prop: keyof T;
  toLeft?: boolean;
  label?: string;
}
function FormCheckBox<T>({
  formData, setFormData, prop, toLeft = false, label = '',
}: FormCheckboxProps<T>): ReactElement {
  return (
    <CheckboxGroup small className={`create-from-form__checkbox ${toLeft ? 'float-left' : 'float-right'}`}>
      <Checkbox
        id={`id-${String(prop)}`}
        checked={formData[prop]}
        onChange={e => setFormData({ ...formData, [prop]: e.target.checked })}
      >&nbsp;{label}
      </Checkbox>
    </CheckboxGroup>
  );
}

export default FormCheckBox;
